import React from "react";

import HaloAxes from "components/HaloAxes";
import HaloPie from "components/HaloPie";
import HaloPlot from "components/HaloPlot";

import dataAccessor from "utils/dataAccessor";

import d3 from "assets/d3/halo";

class HaloChart extends React.Component {
  constructor(props) {
    super(props);

    const { responses, statements } = this.props;

    this.data = this.formatData(statements, responses);

    this.arcOffset = (2 * Math.PI) / ((this.data.length - 1) * 2);
    this.padding = 10;

    this.pie = d3
      .pie()
      .startAngle(Math.PI)
      .endAngle(2 * Math.PI + Math.PI)
      .padAngle((2 * Math.PI) / 1200)
      .value((d) => 1);
  }

  formatData(statements, responses) {
    const filteredData = new dataAccessor(responses);
    let data = [];

    for (let i = 0; i < statements.length; i++) {
      let questionData = filteredData.get(statements[i].id);
      var computed = 0;
      for (let ii = 0; ii < questionData.all.data.length; ii++) {
        let value = questionData.all.data[ii].value;
        computed += (value / responses.length) * (5 - ii);
      }
      data.push(computed.toFixed(2));
    }

    return data;
  }

  render() {
    const width =
        Math.min(this.props.width, this.props.height) - this.padding * 2,
      height = width,
      radius = width / 2,
      pieSize = width / 9,
      pointRadius = 6 * (width / 1000);

    const arcAngleCentroid = d3
      .scaleLinear()
      .domain([0, this.data.length])
      .range([
        Math.PI + this.arcOffset,
        2 * Math.PI + Math.PI + this.arcOffset,
      ]);

    const pieArc = d3
      .arc()
      .innerRadius(radius - pieSize)
      .outerRadius(radius);

    const arcRadius = d3
      .scaleLinear()
      .domain([2, 4])
      .range([radius - pieSize / 2, radius]);

    const arcPath = d3
      .lineRadial()
      .radius((d, i) => {
        return arcRadius(d);
      })
      .angle((d, i) => {
        return arcAngleCentroid(i);
      });

    return (
      <svg height={height + this.padding * 2} width={width + this.padding * 2}>
        <g
          transform={`translate(${this.padding + width / 2},${
            this.padding + height / 2
          })`}
        >
          <HaloPie data={this.pie(this.data)} pieArc={pieArc} />
          <HaloAxes
            arcAngleCentroid={arcAngleCentroid}
            data={this.data}
            pieSize={pieSize}
            radius={radius}
          />
          <HaloPlot
            arcAngleCentroid={arcAngleCentroid}
            arcRadius={arcRadius}
            d={arcPath(this.data)}
            data={this.data}
            pointRadius={pointRadius}
          />
        </g>
      </svg>
    );
  }
}

export default HaloChart;
